import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { toast, ToastContainer } from "react-toastify";
import Button from "../Elements/Button";

const SectionTechniqueDetailsDomaine = () => {
    let { id } = useParams();
    id = parseInt(id);
    const [provider, setProvider] = useState('');
    const [domainURL, setDomainURL] = useState(null);
    const [domainMail, setDomainMail] = useState('');
    const [owner, setOwner] = useState('');
    const [currentProvider, setCurrentProvider] = useState('');
    const [toBuy, setToBuy] = useState(false);
    const [otherRegistrarName, setOtherRegistrarName] = useState('');
    const [showOtherRegistrarInput, setShowOtherRegistrarInput] = useState(false);
    const [existingUp, setExistingUp] = useState(false);
    const [providersName, setProvidersName] = useState([]);

    const [hasAdditionalDomain, setHasAdditionalDomain] = useState(false);
    const [additionalToBuy, setAdditionalToBuy] = useState('');
    const [additionalToRecover, setAdditionalToRecover] = useState('');
    const [redirectRequired, setRedirectRequired] = useState(false);

    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_providers_name/`)
            .then(res => setProvidersName(res.data.result))
            .catch(err => console.error('Erreur get_providers_name :', err));
    }, []);

    const changeProvider = (name) => {
        console.log(name)
        setCurrentProvider(name);

        if (name === "Autre") {
            setShowOtherRegistrarInput(true)
        }
        else {
            setShowOtherRegistrarInput(false)
        }
    };

    const handleChange = (event) => {
        const value = event.target.value;
        setOwner(value);
        setShowOtherRegistrarInput(true);
    };

    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_customer_domain/`, { customer_id: id })
            .then(res => {
                const data = res.data.results;
                setProvider(data.registrar_name);
                setCurrentProvider(data.registrar_name);

                console.log(data.registrar_name)

                setExistingUp(data.existing_up);

                // Domaine supp. à acheter
                data.to_buy && setToBuy(data.to_buy);

                if (data.registrar_name === "Autre"){
                    setShowOtherRegistrarInput(true)
                } else {
                    setShowOtherRegistrarInput(false)
                }
                // Nom custom d'un autre registrar si précisé ("Autre")
                if (data.other_registrar_name) {
                    setOtherRegistrarName(data.other_registrar_name)
                }
                console.log(data)

                switch (data.name) {
                    case "1":
                        setOwner("in_stock");
                        setDomainMail(null);
                        break;
                    case "2":
                        setOwner("to_buy");
                        break;
                    case "3":
                        setOwner("to_recover");
                        break;
                    case "4":
                        setOwner("bought");
                        break;
                    default:
                        setOwner('');
                }

                setDomainURL(data.url);
                setDomainMail(data.mail);

                if (data.supp_to_buy || data.supp_to_get || data.redir_to_make === 1) {
                    setHasAdditionalDomain(true);
                    setAdditionalToBuy(data.supp_to_buy || '');
                    setAdditionalToRecover(data.supp_to_get || '');
                    setRedirectRequired(data.redir_to_make === 1);
                } else {
                    setHasAdditionalDomain(false);
                    setAdditionalToBuy('');
                    setAdditionalToRecover('');
                    setRedirectRequired(false);
                }

            })
            .catch(err => console.error('Error fetching DNS zone:', err));
    }, [id]);

    const saveDomain = () => {
        let numeric_domain_id = 0;
        if (owner === 'in_stock') numeric_domain_id = 1;
        if (owner === 'to_buy') numeric_domain_id = 2;
        if (owner === 'to_recover') numeric_domain_id = 3;
        if (owner === 'bought') numeric_domain_id = 4;

        const bool_existingUp = existingUp ? 1 : 0;
        const bool_toBuy = toBuy ? 1 : 0;

        const payload = {
            customer_id: id,
            domain_name: numeric_domain_id,
            domain_url: domainURL,
            domain_mail: domainMail,
            registrar_name: currentProvider,
            other_registrar_name: otherRegistrarName,
            existing_up: bool_existingUp,
            to_buy: bool_toBuy,
            additional_domain: hasAdditionalDomain ? {
                to_buy: additionalToBuy || '',
                to_recover: additionalToRecover || '',
                redirect: redirectRequired
            } : null
        };

        axios.post(`${API_BASE_URL}/set_customer_domain/`, payload)
            .then(() => toast.success("Domaine modifié."))
            .catch(err => {
                toast.error("Une erreur est survenue lors de l'enregistrement du domaine.");
                console.error('Error saving domain:', err);
            });
    };

    return (
        <>
            <ToastContainer position="bottom-right" autoClose={3000} />
            <div className="display-flex flex-direction-column gap-20">
                <h3 className="color-third">Gestion du domaine</h3>
                <div className="h-separator" />

                <div className="display-flex flex-direction-column gap-20">
                    <h4 className="color-third">Propriétaire</h4>
                    <select
                        onChange={handleChange}
                        value={owner}
                        className="input p-10"
                    >
                        <option value="">-- Sélectionner --</option>
                        <option value="bought">Acheté par SD</option>
                        <option value="in_stock">En notre possession</option>
                        <option value="to_buy">À acheter</option>
                        <option value="to_recover">À récupérer</option>
                    </select>

                    <div className="display-flex flex-direction-column gap-10">
                        <h4 className="color-third">URL du site</h4>
                        <input
                            className="input p-10"
                            placeholder="Par ex. https://solution-digitale.ch"
                            value={domainURL || ''}
                            onChange={(e) => setDomainURL(e.target.value)}
                        />
                    </div>

                    {owner === 'to_recover' && (
                        <>
                            <div className="display-flex flex-direction-column gap-10">
                                <h4 className="color-third">Registraire actuel</h4>
                                <select
                                    onChange={(e) => changeProvider(e.target.value)}
                                    value={currentProvider}
                                    className="input p-10"
                                >
                                    <option value="">-- Sélectionner --</option>
                                    {providersName.map((provider) => (
                                        <option key={provider.id} value={ provider.name}>
                                            {provider.name}
                                        </option>
                                    ))}
                                </select>

                                {showOtherRegistrarInput && (
                                    <input
                                        type="text"
                                        className="input p-10"
                                        placeholder="Nom du registraire"
                                        value={otherRegistrarName}
                                        onChange={(e) => setOtherRegistrarName(e.target.value)}
                                    />
                                )}
                            </div>

                            <div className="display-flex flex-direction-column gap-10">
                                <h4 className="color-third">
                                    Code de transfert ou invitation de compte à compte
                                </h4>
                                <textarea
                                    className="p-10 input min-h-200"
                                    value={domainMail || ''}
                                    onChange={(e) => setDomainMail(e.target.value)}
                                />
                            </div>
                        </>
                    )}

                    <div className="display-flex flex-direction-column gap-10">
                        <h4 className="color-third">Domaine(s) supplémentaire(s) ?</h4>
                        <label className="switch mt-0">
                            <input
                                type="checkbox"
                                checked={hasAdditionalDomain}
                                onChange={() => setHasAdditionalDomain(!hasAdditionalDomain)}
                            />
                            <span className="slider console"></span>
                        </label>
                    </div>

                    {hasAdditionalDomain && (
                        <div className="display-flex flex-direction-column gap-10 mt-10">
                            <h4 className="color-third">Nom(s) de domaine à acheter</h4>
                            <input
                                className="input p-10"
                                placeholder="https://exemple.ch, https://exemple.com"
                                value={additionalToBuy}
                                onChange={(e) => setAdditionalToBuy(e.target.value)}
                            />

                            <h4 className="color-third mt-10">Nom(s) de domaine à récupérer</h4>
                            <input
                                className="input p-10"
                                placeholder="https://exemple.ch, https://exemple.com"
                                value={additionalToRecover}
                                onChange={(e) => setAdditionalToRecover(e.target.value)}
                            />

                            <h4 className="color-third">Redirection à faire ?</h4>
                            <div className="display-flex gap-20">
                                <label>
                                    <input
                                        type="radio"
                                        name="redirect"
                                        checked={redirectRequired}
                                        onChange={() => setRedirectRequired(true)}
                                    /> Oui
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="redirect"
                                        checked={!redirectRequired}
                                        onChange={() => setRedirectRequired(false)}
                                    /> Non
                                </label>
                            </div>
                        </div>
                    )}
                </div>
                <Button onClick={saveDomain} icon={"fa-floppy-disk"}
                        label={"Enregistrer"}
                        textClassNames={"bg-third text-white btn-save"}
                        iconBackground={'bg-fifth'} disableLink/>
            </div>


        </>
    );
};

export default SectionTechniqueDetailsDomaine;
